import LoadingButton from "@/components/common/form/loading-button";
import PrivacyPolicy from "./privacy-policy";
import TermsOfService from "./terms-of-service";

interface IAgreementModalProps {
  open: boolean;
  type?: "agreement" | "privacy-policy" | null;
  ok?: () => void;
  cancel?: () => void;
}

const AgreementModal = ({ open, type, ok, cancel }: IAgreementModalProps) => {
  if (!open) return null;

  const RenderContent = () => {
    let title = "";
    let content = null;
    if (type === "agreement") {
      title = "코드앤버터 이용약관";
      content = <TermsOfService />;
    } else {
      title = "개인정보 처리방침";
      content = <PrivacyPolicy />;
    }

    return (
      <div className="z-50 relative bg-white px-[45px] shadow-[0_5px_15px_0_rgba(0,0,0,0.25)] rounded-[5px]">
        <div className="text-[28px] font-semibold text-black leading-normal text-center py-[47px]">
          {title}
        </div>
        <div className="agreement-content relative p-[15px] pb-[142px] bg-neutral-10 h-[50%] max-h-[710px] overflow-scroll">
          {content}
        </div>
        <div
          className="absolute w-full bottom-0 flex items-center justify-center text-center h-[142px] transform -translate-x-1/2 left-1/2"
          style={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 88.6%)",
          }}
        >
          <LoadingButton
            theme="primary"
            className="w-[346px] text-lg"
            onClick={ok}
          >
            확인
          </LoadingButton>
        </div>
      </div>
    );
  };

  return (
    <div className="absolute top-16 bottom-0 left-0 right-0 w-[900px] h-90vh m-auto">
      <div
        className="grid justify-end mb-[20px] cursor-pointer"
        onClick={cancel}
      >
        <img src="/v2-icon/close-round.svg" alt="close" />
      </div>
      <div className="bg-white">
        <RenderContent />
      </div>
    </div>
  );
};

export default AgreementModal;
